import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import MyLists from './views/MyLists.vue'
import ViewList from './views/ViewList.vue'
import About from './views/About.vue'
import Login from './views/Login.vue'
import Registration from './views/Registration.vue'
import VerifyEmail from './views/VerifyEmail.vue'
import Imprint from './views/Imprint.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Imprint
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/registration',
      name: 'registration',
      component: Registration
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/my-lists',
      name: 'my-lists',
      component: MyLists
    },
    {
      path: '/verify-email/',
      name: 'verify-email-empty',
      component: VerifyEmail
    },
    {
      path: '/verify-email/:token',
      name: 'verify-email',
      component: VerifyEmail
    },
    {
      path: '/:token',
      name: 'edit-list',
      component: ViewList
    }
  ]
})
